import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[addAaTags]'
})
export class AddAaTagsDirective {
  @Input('addAaTags') addAaTags: any = '';

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    const parentElement = this.el.nativeElement; // Get the parent element
    if (parentElement) {
      const parentTag = parentElement.tagName.toLowerCase(); // Get the parent tag name in lowercase
      switch (true) {
        case parentTag.includes('img'):
          this.el.nativeElement.setAttribute('aria-label', this.addAaTags);
          this.el.nativeElement.setAttribute('alt', this.addAaTags);
          this.el.nativeElement.setAttribute('arialabelledby', this.addAaTags);
          break;

        case parentTag.includes('button'):
          this.el.nativeElement.setAttribute('aria-label', this.addAaTags);
          this.el.nativeElement.setAttribute('aria-describedby', this.addAaTags);
          break;

        case parentTag.includes('a'):
          this.el.nativeElement.setAttribute('aria-label', this.addAaTags);
          this.el.nativeElement.setAttribute('alt', this.addAaTags);
          this.el.nativeElement.setAttribute('arialabelledby', this.addAaTags);
          break;
          
        case parentTag.includes('label'):
          
          break;
      
        default:
          break;
      }
    }
  }

}
